import { Injectable } from '@angular/core';

@Injectable()
export class AtxPermissionModel {
    private _roles: string[] = [];
    private _rolesRequired: string[];

    get roles() {
        return this._roles;
    }

    get rolesRequired() {
        return this._rolesRequired;
    }

    set roles(data) {
        this._roles = data;
    }

    public setAccessRequired(config, url: string = location.pathname) {
        url = url.slice(1);

        const element = (<any>config.find((route) => route.path === url));

        this._rolesRequired = element && element.rolesRequired;
    }
}
